<template>
  <button
    class="plv-iar-default-btn pws-btn-bg-color pws-iar-primary-button"
    :class="{
      [typeClass]: true,
      'is-disabled': disabled,
    }"
    :disabled="disabled"
    :style="btnStyle"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
    },
    btnStyle: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: ''
    },
  },
  computed: {
    typeClass() {
      let btnTypeClass = '';
      const arr = ['cancel', 'delete'];
      if (arr.includes(this.type)) {
        btnTypeClass = `plv-iar-btn--${this.type}`;
      }
      return btnTypeClass;
    },
  }

};
</script>

<style lang="scss">
.plv-iar-default-btn {
  position: relative;
  display: inline-block;
  margin: 0 auto;
  width: 100%;
  padding: 13px 20px;
  background: #3082FE;
  border-radius: 25px;
  border: none;
  outline: none;
  color: #fff;
  cursor: pointer;
  //transition: .15s all ease-in-out;
  font-size: 16px;

  &:active {
    background: rgba(33, 150, 243, 0.9);
  }

  &:disabled {
    background: rgba(48, 130, 254, 0.6);
  }
  &--cancel {
    margin-right: 12px;
    border: 1px solid #2196F3;
    background: #fff;
    color: #333;
  }
}
</style>
